import { render } from "./content-card.vue?vue&type=template&id=20ba7274"
import script from "./content-card.vue?vue&type=script&lang=js"
export * from "./content-card.vue?vue&type=script&lang=js"

import "./content-card.vue?vue&type=style&index=0&id=20ba7274&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__